import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/services/cloudnative'

const CloudNative: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])

  return (
    <>
      <CustomHead
        keyword={'クラウドネイティブ サーバーレス AWS DevOps インフラ 運用'}
        image={'https://www.i3design.jp/img/ogp_logo.png'}
        url={'https://www.i3design.jp/services/cloudnative/'}
        title="クラウドネイティブ|サービス|i3DESIGN アイスリーデザイン"
        description="クラウドリフト後の次の一手として、サーバーレスとデータ統合基盤を活用し、真のクラウドネイティブを実現します。包括的なアーキテクチャ設計からDevOpsの導入、継続的な運用支援までを一貫して提供し、ステップ導入によって無理なくクラウドネイティブへの移行を支援します。"
      />
      <Template />
    </>
  )
}

export default CloudNative
